export const PRISMIC_API_ENDPOINT = 'https://withlocals.cdn.prismic.io/api/v2';
export const PRISMIC_API_ENDPOINT_V2 =
  'https://withlocalscontent.cdn.prismic.io/api/v2';
export const PRISMIC_API_ENDPOINT_V2_TOKEN =
  'MC5YWFp1M2hBQUFDVUFDWXNS.77-977-977-9L--_vSXvv73vv73vv70b77-9DSLvv71x77-9TXJhMe-_vVnvv73vv71l77-9HO-_vQzvv73vv70B';

export const LOCATION_PAGE_DOCUMENT_TYPE = 'new-location-page';
export const LOCATION_PAGE_INTERLINKING_DOCUMENT_TYPE = 'new-location-links';
export const INFORMATION_PAGE_DOCUMENT_TYPE = 'info_page';
export const LEARNING_CENTER_DOCUMENT_TYPE = 'learning_center';
export const PARTNER_CENTER_DOCUMENT_TYPE = 'partner_center';
export const CLASSICS_DOCUMENT_TYPE = 'wlo_classics';
export const LIVE_DOCUMENT_TYPE = 'wl_live';
export const WL_CONNECT_DOCUMENT_TYPE = 'wl_connect';
export const HOST_TOOLS_DOCUMENT_TYPE = 'host_tools';
export const COLLECTION_DOCUMENT_TYPE = 'collection';
export const COURSE_DOCUMENT_TYPE = 'course';
